import * as FullStory from '@fullstory/browser';

export function captureEvent(name: string, data: any) {
  try {
    FullStory.event(name, data);
  } catch {
    // Noop: FS might not be loaded/blocked.
  }
}
